/* @flow */

/**
 * This is a shared style between all Tags components
 */

import { rem, em, mix } from 'polished';

import { tintDuration } from '@braindate/ui/lib/token/animation';
import { baseFontSize } from '@braindate/ui/lib/token/typography';

const sidePadding = 16;
export default {
  root: {
    display: 'inline-block',
    width: 'auto',
    alignItems: 'center',
    position: 'relative',

    padding: [em(8, baseFontSize), em(sidePadding, baseFontSize)],

    backgroundColor: ({ theme, isInactive, isChecked }: Object) => {
      if (isInactive) {
        return mix(0.06, theme.textColor, theme.colorBase);
      }
      if (isChecked) {
        return theme.accentColor;
      }
      return mix(0.03, theme.accentColor, theme.colorBase);
    },
    border: ({ theme, isInactive }: Object) =>
      `solid 1px ${
        isInactive
          ? mix(0.6, theme.textColor, theme.colorBase)
          : theme.accentColor
      }`,
    borderRadius: 8,
    color: ({ theme, isInactive, isChecked }: Object) => {
      if (isInactive) {
        return mix(0.6, theme.textColor, theme.colorBase);
      }
      if (isChecked) {
        return theme.textColorReverse;
      }
      return theme.accentColor;
    },

    fontSize: rem(14, baseFontSize),
    fontWeight: 500,
    whiteSpace: 'nowrap',

    transformOrigin: 'center center',
    transition: `background-color ${tintDuration}, color ${tintDuration}`,
    minHeight: 0,
    minWidth: 0,
    lineHeight: 1.3,
    opacity: '1 !important',

    '&:hover': {
      textDecoration: 'none',
      backgroundColor: ({ theme, isInactive, isChecked }: Object) =>
        !isInactive &&
        !isChecked &&
        mix(0.1, theme.accentColor, theme.colorBase),
    },
  },

  dismiss: {
    marginLeft: 8,
    marginTop: '2px',
  },

  rootWithRadio: {
    padding: 0,
    margin: 0,

    '& input:checked + label:before': {
      outlineColor: 'white !important',
    },
  },

  label: {
    padding: [em(8, baseFontSize), em(sidePadding, baseFontSize)],
    paddingLeft: `${em(sidePadding + 20, baseFontSize)} !important`,
    margin: '0 !important',
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: em(14, baseFontSize),
    color: ({ theme, isInactive, isChecked }: Object) => {
      if (isInactive) {
        return mix(0.6, theme.textColor, theme.colorBase);
      }
      if (isChecked) {
        return theme.textColorReverse;
      }
      return theme.accentColor;
    },
    '&:before': {
      left: `${sidePadding}px !important`,
    },
  },
};
